import React, { Component, Fragment } from 'react';
import { ReflectionComponent } from './ReflectionComponent';
import { getReflections, createReflection } from '../api/ReflectionsApi';

export class ReflectionListComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reflections: [],
      activeReflectionId: 0
    };
    this.fetchExistingDocument();
  }

  fetchExistingDocument() {
    getReflections(this.props.reflectionType, (data) => { this.loadReflections(data) }, (response) => {
      if (response.status == 401) {
        return window.open(`${process.env.API_HOST}/users/sign_in`, '_self');
      }
    })
  }

  handleClick(selectedReflection) {
    this.setState({activeReflectionId: selectedReflection.id});
  }

  loadReflections(persistedReflections) {
    const latestReflection = persistedReflections[0];

    var newState = {reflections: persistedReflections};

    if(this.shouldGenerateReflection(latestReflection)){
      this.generateNewReflection();
    }
    else {
      newState.activeReflectionId = latestReflection.id
    }

    this.setState(newState);
  }

  renderReflections() {
    return this.state.reflections.map((reflection, index) => (
      <ReflectionComponent key={reflection.id + '-' + this.state.activeReflectionId} reflectionType={this.props.reflectionType} reflection={reflection} makeActive={this.handleClick.bind(this)} activeReflectionId={this.state.activeReflectionId} authenticityToken={this.props.authenticityToken} />
    ));
  }

  render() {
    return (
      <div className='reflection-list'>{this.renderReflections()}</div>
    );
  }

  // Determines if a new Reflection record should be generated
  // If no reflections exist, return true
  // create a new weekly reflection every 5 days
  // create a new monthly reflection everytion 25 days
  shouldGenerateReflection(latestReflection) {
    // Force to true
    // return true;
    // If the user has no reflections, we should generate
    if(latestReflection === undefined)
      return true;

    // If today is Sunday, we should generate
    const today = new Date();
    const lastReflectionCreatedAt = new Date(latestReflection.created_at);

    if(this.props.reflectionType == 'weekly') {
      // Create one every 5 days from the last one
      const is5DaysOld = (((today - lastReflectionCreatedAt) / (1000 * 60 * 60 * 24)) > 5);
      return is5DaysOld;
    }
    else if(this.props.reflectionType == 'monthly') {
      const wasLastReflectionCreatedThisMonth = (today.getMonth() == lastReflectionCreatedAt.getMonth());
      const wasLastReflectionCreatedInTheLast7Days = (((today - lastReflectionCreatedAt) / (1000 * 60 * 60 * 24)) < 7);
      return !(wasLastReflectionCreatedThisMonth || wasLastReflectionCreatedInTheLast7Days);
    }
    else {
      return today.toDateString() != lastReflectionCreatedAt.toDateString();
    }
  }

  generateNewReflection() {
    const dateString = new Date().toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' })
    const newDailyReflection = "<b>" + dateString + "</b><h1>What do I want to accomplish today?</h1><ul><li>Your most urgent item...</li><li>Your most important item...</li><li>One more thing you want to get done...</li><li><del>Something you already got done today...</del></li></ul><br/>";
    const newWeeklyReflection = "<b>" + dateString + "</b><h1 class=\"phase phase-1\"><!--block-->Where am I?</h1><ul><li class=\"stage stage-1\"><!--block-->What're you feeling right at this moment?<ul><li class=\"stage stage-2\"><!--block--><br></li></ul></li><li><!--block-->Before we jump ahead to the week ahead, let's first think back and reflect on the past week. What were some wins (big or small)? What were some moments (big or small) that made you smile?<ul><li><!--block--><br></li></ul></li></ul><h1 class=\"phase phase-2\"><!--block-->What do I do next?</h1><ul><li class=\"stage stage-3\"><!--block-->Now, as you look ahead to the coming week, and now that you've reflected on where you are and where you've been, what are your 3 non-negotiables for the coming week? (write them as if you've already accomplished them by next Sunday)<ol><li><!--block-->&nbsp;</li><li><!--block-->&nbsp;</li><li class=\"stage stage-4\"><!--block-->&nbsp;</li></ol></li><li class=\"stage stage-5\"><!--block-->Here at Unstoppable, we believe that if it's not on your calendar then it's not a priority. Now that you've reflected on your priorities, let's pull up your calendar.<ul><li class=\"stage stage-6\"><!--block-->What're the things that are on your calendar that no longer make sense and you should cut? Can you de-prioritize them?</li><li class=\"stage stage-6\"><!--block-->Now, can you make sure that you've allocated time to work on your 3 non-negotiables that you've committed to above and make sure they're a priority in the week ahead?</li></ul></li><li class=\"stage stage-7\"><!--block-->Now. Lastly, now that you've reflected on where you are right now, expressed gratitude for the week that just passed, and set your priorities for the coming week; let's do one last thing. Is there something you can add to your calendar, something extra, something for yourself, that you can look forward to doing at the end of this week? What will it be?<ul><li><!--block-->&nbsp;</li></ul></li></ul><div><!--block--><br></div>";
    const newMonthlyReflection = "<b>" + dateString + "</b>" + `
    <h1 class="phase phase-1"><!--block-->Past Month</h1><ul>
        <li class="stage stage-1">
            What was the ONE BIG goal that you set to accomplish last month? How did it go?
            <ul>
                <li>
                    <!--block-->
                    <br />
                </li>
            </ul>
        </li>
        <li class="stage stage-2">
            <!--block-->What were 3 wins (big or small) from the past month?
            <ul>
                <li><!--block-->&nbsp;</li>
                <li><!--block-->&nbsp;</li>
                <li><!--block-->&nbsp;</li>
            </ul>
        </li>
        <li class="stage stage-3"><!--block-->What worked well? What held you back?
	        <ul>
	            <li><!--block-->&nbsp;</li>
	            <li><!--block-->&nbsp;</li>
	        </ul>
        </li>
    </ul><h1 class="phase phase-2"><!--block-->Next Month</h1><ul>
        <li class="stage stage-4">
            What is your ONE BIG GOAL for this month?
            <ul>
                <li>&nbsp;&nbsp;</li>
            </ul>
        </li>
        <li class="stage stage-5">
            How does accomplishing this goal help you get closer to accomplishing your 365-day goals? Why is this goal important?
            <ul>
                <li>&nbsp;</li>
            </ul>
        </li>
        <li class="stage stage-6">
            What will you approach differently / double down on this month?
            <ul>
                <li>&nbsp;</li>
            </ul>
        </li>
        <li class="stage stage-7">
            Who should you ask for help / can model?
            <ul>
                <li>&nbsp;</li>
            </ul>
        </li>
    </ul>
    `;
    var content;
    if(this.props.reflectionType == 'weekly') {
      content = newWeeklyReflection;
    }
    else if(this.props.reflectionType == 'monthly') {
      content = newMonthlyReflection;
    }
    else {
      content = newDailyReflection;
    }
    createReflection(
      {
        reflection: {reflection_type: this.props.reflectionType, content: content}
      },
      this.props.authenticityToken,
      (data) => {
        this.handleNewReflectionCreated(data);
      },
      (response) => {
        if(response.status == 401) {
          return window.open(`${process.env.API_HOST}/users/sign_in`, '_self');
        }
      }
    );
  }

  handleNewReflectionCreated(data) {
    var reflections = this.state.reflections;
    reflections.unshift(data);

    this.setState({
      reflections: reflections,
      activeReflectionId: data.id
    });
  }
}
